import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../@core/auth/auth.service';
import { Employee } from '../../models/employee';


@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getEmployees(): Observable<Employee[]> {
    return this.httpClient.get<Employee[]>(`${this.basePath}/api/Employees`);
  }

  public putEmployee(employee: Employee): Observable<Employee> {
    return this.httpClient.put<Employee>(`${this.basePath}/api/Employees/${employee.id}`, employee);
  }


  public postEmployee(employee: Employee): Observable<Employee> {

    if (environment.isMockEnabled) {
      return of(employee);
    }
    return this.httpClient.post<Employee>(`${this.basePath}/api/Employees`,
      employee);
  }

  public deleteEmployee(id: number): Observable<Employee> {
    let queryParameters = new HttpParams();
    queryParameters = queryParameters.set('setInactive', "false");

    return this.httpClient.delete<Employee>(`${this.basePath}/api/Employees/${id}`,
      {
        params: queryParameters,
      }
    );
  }
}


